"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('selector');
let currentParent = null;
const Selector = (props) => {
    const { value = [], options = [], style, onChange, onChangeParentOption } = props;
    const [parentData, setParentData] = react_1.useState([]);
    const [childrenData, setChildrenData] = react_1.useState([]);
    const [activeParent, setActiveParent] = react_1.useState('');
    react_1.useEffect(() => {
        if (options.length > 0) {
            const data = options[0].children || [];
            currentParent = options[0];
            setActiveParent(currentParent.key);
            setParentData(options);
            setChildrenData(data);
        }
    }, [options]);
    const handleClickParentOption = (option) => {
        const data = option.children || [];
        currentParent = option;
        setChildrenData(data);
        setActiveParent(option.key);
        onChangeParentOption === null || onChangeParentOption === void 0 ? void 0 : onChangeParentOption(option);
    };
    const handleClickChildrenOption = (option) => {
        onChange === null || onChange === void 0 ? void 0 : onChange([currentParent.key, option.key], `${currentParent.value} ${option.value}`);
    };
    return (React.createElement(one_1.View, { className: prefixCls, style: style },
        React.createElement(one_1.View, { className: `${prefixCls}-parent` }, parentData === null || parentData === void 0 ? void 0 : parentData.map((option, index) => (React.createElement(one_1.View, { key: option.key, className: classnames_1.default({
                [`${prefixCls}-option`]: true,
                [`${prefixCls}-active`]: activeParent === option.key,
            }), onTap: () => {
                handleClickParentOption(option);
            } },
            option.value,
            activeParent === option.key && index !== 0 ? (React.createElement(one_1.View, { className: `${prefixCls}-option-rounded_top` },
                React.createElement(one_1.View, { className: `${prefixCls}-option-rounded_top-circle` }))) : null,
            activeParent === option.key ? (React.createElement(one_1.View, { className: `${prefixCls}-option-rounded_bottom` },
                React.createElement(one_1.View, { className: `${prefixCls}-option-rounded_bottom-circle` }))) : null)))),
        React.createElement(one_1.View, { className: `${prefixCls}-children` }, childrenData === null || childrenData === void 0 ? void 0 : childrenData.map(option => (React.createElement(one_1.View, { key: option.key, className: classnames_1.default({
                [`${prefixCls}-option`]: true,
                [`${prefixCls}-active`]: (value === null || value === void 0 ? void 0 : value[1]) === option.key,
            }), onTap: () => {
                handleClickChildrenOption(option);
            } }, option.value))))));
};
exports.default = Selector;
